var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnbStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / onb-step-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-21.4%",
    y: "-25.0%",
    width: "142.9%",
    height: "149.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83BFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8BF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1914765,76.8348097 L70.1914765,96.528076 C70.183346,99.6217074 67.6774836,102.12757 64.5838522,102.1357 L54.2267625,102.1357 C51.1331311,102.12757 48.6272687,99.6217074 48.6191382,96.528076 L48.6191382,76.7904222 L5.79997023,32.4028949 C2.23871839,29.4109119 0.127755832,25.0382037 0,20.3886709 C0,10.9637192 8.55199692,4.24640678 20.8177503,0 C21.6785233,1.49316426 22.7387852,2.86204699 23.9692647,4.06885667 L32.4472824,12.6060577 C22.2233553,15.0473718 16.5713435,18.4356197 15.4616553,20.3886709 C17.2667481,23.7177354 32.0329989,31.1156566 59.4792866,31.1156566 C86.9255743,31.1156566 101.691825,23.7177354 103.496918,20.4330584 C102.416821,18.494803 96.7352178,15.1065551 86.5704741,12.6504453 L95.0484918,4.1132442 C95.7158333,3.44357222 96.3339348,2.72657448 96.8979721,1.96784704 C97.3476469,1.35334949 97.7578248,0.710902211 98.126027,0.0443875273 C110.39178,4.2907943 118.928981,11.0081068 118.928981,20.4330584 C118.89639,24.4708263 117.306263,28.3401363 114.490229,31.2340234 L70.1914765,76.8348097 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "56.9004782%",
    x2: "50.9086715%",
    y2: "72.7429778%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-45.3%",
    y: "-39.0%",
    width: "190.7%",
    height: "178.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.4439111%",
    y1: "12.606072%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89522",
    offset: "95.988497%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.49266654,30.9236966 C4.93006442,31.0302749 4.37977916,31.1938732 3.85032803,31.4119594 C3.32663092,31.617456 2.82980495,31.8857421 2.37074379,32.2109349 C1.35705418,32.9387955 0.608903226,33.977894 0.240142482,35.1701034 C0.0370390566,35.8253334 -0.0383053568,36.513479 0.0182048451,37.1971338 C0.0749186062,37.8734882 0.25020976,38.5345863 0.53605933,39.150185 C0.841806276,39.8081796 1.25146463,40.4126755 1.74931841,40.9404819 L22.729823,63.2230206 C23.0575768,63.5706519 23.4250631,63.8785458 23.8247153,64.1403629 C24.2340302,64.411635 24.6703758,64.6397248 25.1267494,64.8209716 C25.6054607,65.0063655 26.1009545,65.1451038 26.6063337,65.2352552 C27.6380025,65.4285086 28.6965876,65.4285086 29.7282564,65.2352552 C30.2336976,65.1453752 30.7292174,65.0066297 31.2078407,64.8209716 C31.6643483,64.6400172 32.1007235,64.4119119 32.5098748,64.1403629 C32.90395,63.8827698 33.2664578,63.5798522 33.5899713,63.2378165 L54.466905,40.9404819 C54.7087371,40.6808868 54.9312678,40.4039597 55.1327179,40.1119148 C55.3285655,39.8301738 55.5017281,39.5333238 55.6505724,39.2241642 C55.7957404,38.9192295 55.9145408,38.6024286 56.0056726,38.2772303 C56.1140457,37.9545272 56.1932739,37.6227591 56.2424061,37.2859089 C56.2601463,37.0346924 56.2601463,36.7825374 56.2424061,36.5313209 C56.2124091,35.7762514 56.0259942,35.0356303 55.6949599,34.3563321 C55.4295242,33.8118321 55.0800078,33.312523 54.6592509,32.8767478 C54.2229143,32.4324725 53.7245495,32.0537153 53.1796667,31.7522638 C52.6055974,31.4463717 51.9936916,31.2175289 51.3597781,31.071655 C50.6971742,30.903929 50.01625,30.8194348 49.3327477,30.8201257 L40.5884048,30.8201257 L41.6241138,7.14677784 C41.6653111,6.22322832 41.5141579,5.30119366 41.1802385,4.43913868 C40.8465809,3.58281529 40.3433134,2.80275062 39.7006542,2.1457831 C39.0372031,1.47509068 38.2477696,0.942097326 37.377707,0.577423802 C36.4406527,0.186402709 35.4338522,-0.00992340142 34.4185385,0 L21.8124807,0 C20.7971671,-0.00992340142 19.7903665,0.186402709 18.8533123,0.577423802 C18.0043606,0.948824138 17.2355588,1.48145808 16.5895484,2.1457831 C15.9468892,2.80275062 15.4436217,3.58281529 15.1099641,4.43913868 C14.7648664,5.31391383 14.6085601,6.25175177 14.651293,7.19116537 L15.687002,30.8645133 L7.26816764,30.8645133 C6.67440328,30.8439512 6.08001293,30.878624 5.49266654,30.9680842 L5.49266654,30.9236966 Z",
    id: "path-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-onb-step-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_filter_834249",
    transform: "translate(15.800000, 2.000358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    filter: "url(#filter-1)",
    transform: "translate(0.000000, 42.863941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.318171,21.0554013 L121.450045,-16.2647427 L35.992179,83.7376001 C42.9691426,104.127387 54.7835277,110.751227 71.4353343,103.609119 C82.5479557,98.842817 86.8140555,100.125983 84.5399861,78.093413 C83.7842993,70.7718591 97.7103609,51.7591885 126.318171,21.0554013 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    filter: "url(#filter-6)",
    transform: "translate(31.348981, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.96919,-0.0806572063 L96.101064,-37.4008012 L10.6431979,62.6015416 C17.6201615,82.9913286 29.4345466,89.6151682 46.0863532,82.4730605 C57.1989746,77.7067585 61.4650744,78.9899241 59.191005,56.9573545 C58.4353182,49.6358005 72.3613798,30.62313 100.96919,-0.0806572063 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnbStep2);
export default __webpack_public_path__ + "static/media/onb-step-2.beed1d731fda2c3a0b6504ec5a84a2a0.svg";
export { ForwardRef as ReactComponent };